// apps/landing-page/src/lib/api/referral.ts
const API_BASE = '/api/proxy';

export interface ReferralReward {
  id: string;
  rewardTarget: 'REFERRER' | 'REFEREE';
  status: 'PENDING' | 'ISSUED' | 'REDEEMED' | 'EXPIRED' | 'REVOKED' | string;
  expiresAt: string | null;
  /** Redeemable code — non-null only while status is ISSUED. */
  voucherCode: string | null;
}

export const referralApi = {
  /**
   * The signed-in user's referral rewards. Auth rides on the httpOnly
   * aks_session cookie the proxy forwards, same as the payment client.
   * Returns [] for anonymous visitors rather than throwing — callers use this
   * to decorate the cart, and it must never block checkout.
   */
  async getMyRewards(): Promise<ReferralReward[]> {
    try {
      const res = await fetch(`${API_BASE}/referrals/me/rewards`, {
        credentials: 'same-origin',
      });
      if (!res.ok) return [];
      return await res.json();
    } catch {
      return [];
    }
  },
};
